var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1673 7.33333V5.66667C12.1673 3.36548 10.3018 1.5 8.00065 1.5C5.69947 1.5 3.83398 3.36548 3.83398 5.66667V7.33333M8.00065 11.0833V12.75M5.33398 16.5H10.6673C12.0675 16.5 12.7675 16.5 13.3023 16.2275C13.7727 15.9878 14.1552 15.6054 14.3948 15.135C14.6673 14.6002 14.6673 13.9002 14.6673 12.5V11.3333C14.6673 9.93317 14.6673 9.23317 14.3948 8.69833C14.1552 8.22792 13.7727 7.8455 13.3023 7.60583C12.7675 7.33333 12.0675 7.33333 10.6673 7.33333H5.33398C3.93385 7.33333 3.23378 7.33333 2.69901 7.60583C2.2286 7.8455 1.84615 8.22792 1.60647 8.69833C1.33398 9.23317 1.33398 9.93317 1.33398 11.3333V12.5C1.33398 13.9002 1.33398 14.6002 1.60647 15.135C1.84615 15.6054 2.2286 15.9878 2.69901 16.2275C3.23378 16.5 3.93385 16.5 5.33398 16.5Z",
    stroke: "black",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.15f9782f985bb38844d1c891b6b0e763.svg";
export { ForwardRef as ReactComponent };